/** A letter in any script (Georgian included) or a digit; named keys (`Enter`, `ArrowDown`, `F4`…) are longer than one character and never match. */
const LETTER_OR_DIGIT_PATTERN = /^[\p{L}\p{N}]$/u;

/**
 * The sale screen's one rule for a keystroke that belongs in search: the
 * product grid and the cart both send exactly these keys there instead of
 * acting on them. A letter or digit in any script, with or without Shift —
 * the Georgian letters შ ჭ ღ თ ჟ ძ ჩ need Shift, and a scanner sends Shift
 * for a capital. Never with Ctrl, Alt or Meta (those are shortcuts or the
 * browser's own, like `Ctrl+-` zoom), never a held key repeating, never a key
 * pressed mid-IME composition. Space and punctuation are not search keys:
 * Space and Enter still activate a focused button.
 */
export const isPrintableKey = (event: KeyboardEvent): boolean =>
    !event.ctrlKey &&
    !event.altKey &&
    !event.metaKey &&
    !event.repeat &&
    !event.isComposing &&
    LETTER_OR_DIGIT_PATTERN.test(event.key);
